var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5785 1.15576H2.91755C2.06397 1.15576 1.60279 2.1563 2.15722 2.8053L9.70838 11.6444C9.86306 11.8255 9.94805 12.0558 9.94805 12.294V20.5833C9.94805 21.3155 10.709 21.7995 11.3721 21.489L13.9721 20.2716C14.3235 20.107 14.548 19.754 14.548 19.366V12.294C14.548 12.0558 14.633 11.8255 14.7877 11.6444L22.3389 2.8053C22.8933 2.1563 22.4321 1.15576 21.5785 1.15576Z",
    stroke: "#FF9349",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelIcon);
export default __webpack_public_path__ + "static/media/funnel_icon.1ef42fc5b8d4109e1ce57d1620c23a7d.svg";
export { ForwardRef as ReactComponent };